import { ChevronRight } from 'lucide-react'
import type { ReactNode } from 'react'

import { cn } from 'src/shared/utils/cn'

export type TableItem = {
  title: string
  leftIcon?: ReactNode
  subtitle?: string
  rightText?: string
  onClick?: () => void
  hideArrow?: boolean
  alignCenter?: boolean
}

type ConradInfoTableProps = {
  items: TableItem[]
}

const ConradInfoTable = ({ items }: ConradInfoTableProps) => {
  if (items.length === 0) return null

  return (
    <div className="flex w-full flex-col rounded-[12px] bg-accent">
      {items.map((item, index) => {
        const isClickable = Boolean(item.onClick)

        const RowTag = isClickable ? 'button' : 'div'

        return (
          <div key={`${item.title}-${index}`}>
            <RowTag
              {...(isClickable ? { type: 'button', onClick: item.onClick } : {})}
              className={cn(
                'flex w-full flex-row justify-between gap-10 px-5 py-4',
                item.alignCenter ? 'items-center' : 'items-start',
                isClickable && 'cursor-pointer',
              )}
            >
              <div className="flex min-w-0 flex-1 flex-row gap-3">
                {item.leftIcon ? (
                  <div className="mt-0.5 flex shrink-0 items-center justify-center">{item.leftIcon}</div>
                ) : null}
                <div className="flex min-w-0 flex-col">
                  <p className="text-left text-sm font-medium text-primary">{item.title}</p>
                  {item.subtitle ? <p className="text-left text-xs text-primary/75">{item.subtitle}</p> : null}
                </div>
              </div>

              <div className="flex max-w-[45%] flex-row items-center justify-end gap-1">
                {item.rightText ? (
                  <p className="line-clamp-2 break-words text-right text-sm text-muted">{item.rightText}</p>
                ) : null}
                {!item.hideArrow ? <ChevronRight size={18} className="shrink-0 text-muted" /> : null}
              </div>
            </RowTag>

            {index < items.length - 1 ? <div className="h-px bg-lightBorder" /> : null}
          </div>
        )
      })}
    </div>
  )
}

export default ConradInfoTable
